export class Airport {
	id: number;
	iata: string;
	icao: string;
	name: string[];
}
